import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=b3e56d72&"
import script from "@/views/ResetPassword/ResetPassword.ts?vue&type=script&lang=ts&"
export * from "@/views/ResetPassword/ResetPassword.ts?vue&type=script&lang=ts&"
import style0 from "@/views/ResetPassword/reset-password.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
